import templateComponents from '../../../Template/theme/components'
import scorecard from './scorecard'
import quickview from './quickview'

export default {
    ...templateComponents,
    quickview,
    scorecard
}


// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/theme/components/index.js